<template>
  <v-main style="min-height: 70vh">
    <v-container class="responsive-template-content">
      <v-row dense>
        <v-col cols="12">
          <v-card
            color="white"
            dark
            elevation="24"
            class="rounded-xl"
            style="padding: 2em"
          >
            <v-card-title
              class="text-h4 font-weight-lighter"
              style="justify-content: center; color: grey"
            >
              <v-icon color="grey" left large>
                mdi-folder-table-outline
              </v-icon>
              Consulter mes offres d'emplois
            </v-card-title>
            <v-card-text></v-card-text>
            <v-row dense>
              <v-col cols="12" md="3">
                <v-btn
                  elevation="24"
                  large
                  rounded
                  color="primary"
                  v-on:click="hideModalComponent"
                  to="/company/new/offer"
                >
                  <v-icon left> mdi-file-plus-outline</v-icon>
                  Publier une nouvelle offre
                </v-btn>
              </v-col>
            </v-row>

            <v-tabs v-model="tab" light class="ma-5">
              <v-tabs-slider color="blue"></v-tabs-slider>
              <v-tab
                v-for="item in items"
                :key="item"
                style="padding-top: 1em; margin-right: 0.5em"
              >
                <v-badge
                  color="green"
                  :content="
                    item === items[0]
                      ? activeJobsItems.length
                      : inactiveJobsItems.length
                  "
                >
                  <v-icon left v-if="item === items[0]">
                    mdi-folder-check-outline
                  </v-icon>
                  <v-icon left v-if="item === items[1]">
                    mdi-publish-off
                  </v-icon>
                  {{ item }}
                </v-badge>
              </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
              <v-tab-item :key="items[0]">
                <v-card flat>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12">
                        <v-card
                          color="white"
                          dark
                          elevation="0"
                          class="rounded-xl mt-3"
                        >
                          <v-card-title>
                            <v-alert
                              icon="mdi-information-outline"
                              prominent
                              text
                              type="info"
                              width="100%"
                            >
                              <p class="font-weight-thin">
                                Dans cette section, vous retrouverez les offres
                                d'emplois qui sont actives en ligne triée par
                                date de publication décroissante.
                              </p>
                            </v-alert>
                          </v-card-title>
                          <v-card-text>
                            <v-row dense class="pa-3">
                              <v-col cols="12">
                                <v-list two-line elevation="1" light>
                                  <v-list-item-group
                                    v-model="selected"
                                    multiple
                                  >
                                    <template
                                      v-for="(item, index) in updateVisibleJobs"
                                    >
                                      <v-list-item
                                        color="white"
                                        :key="item.id"
                                        v-on:click="viewJobOffer(item.id)"
                                      >
                                        <template>
                                          <v-list-item-content>
                                            <v-list-item-title
                                              v-text="item.title"
                                              style="color: black"
                                            ></v-list-item-title>

                                            <v-list-item-subtitle
                                              style="color: #1565c0"
                                              class="font-weight-medium"
                                              v-text="item.headline"
                                            ></v-list-item-subtitle>

                                            <v-list-item-subtitle
                                              v-html="
                                                `${item.subtitle.substr(
                                                  0,
                                                  50
                                                )} ...`
                                              "
                                            ></v-list-item-subtitle>
                                          </v-list-item-content>

                                          <v-list-item-action>
                                            <v-list-item-action-text
                                              v-html="
                                                getListItemAction(item.action)
                                              "
                                            >
                                            </v-list-item-action-text>
                                          </v-list-item-action>
                                        </template>
                                      </v-list-item>

                                      <v-divider
                                        v-if="
                                          index < activeJobsItems.length - 1
                                        "
                                        :key="index"
                                        inset
                                        style="
                                          color: #6b6868;
                                          margin-left: 0px;
                                          max-width: 100% !important;
                                        "
                                      ></v-divider>
                                    </template>

                                    <v-pagination
                                      v-model="page"
                                      :length="
                                        Math.ceil(
                                          activeJobsItems.length / perPage
                                        )
                                      "
                                      circle
                                    >
                                    </v-pagination>
                                  </v-list-item-group>
                                </v-list>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>

              <v-tab-item :key="items[1]">
                <v-card flat>
                  <v-card-text>
                    <v-row>
                      <v-col cols="12">
                        <v-card
                          color="white"
                          dark
                          elevation="0"
                          class="rounded-xl mt-3"
                        >
                          <v-card-title>
                            <v-alert
                              icon="mdi-information-outline"
                              prominent
                              text
                              type="info"
                              width="100%"
                            >
                              <p class="font-weight-thin">
                                Dans cette section, vous retrouverez les offres
                                d'emplois désactivées mais non supprimées. Elles
                                n'apparaissent plus dans les résultats de
                                recherche mais uniquement dans les offres
                                sauvegardées par les candidats.
                              </p>
                            </v-alert>
                          </v-card-title>
                          <v-card-text>
                            <v-row dense class="pa-3">
                              <v-col cols="12">
                                <v-list two-line elevation="1" light>
                                  <v-list-item-group
                                    v-model="selected"
                                    multiple
                                  >
                                    <template
                                      v-for="(
                                        item, index
                                      ) in updateDisabledVisibleJobs"
                                    >
                                      <v-list-item
                                        color="white"
                                        :key="item.id"
                                        v-on:click="viewJobOffer(item.id)"
                                      >
                                        <template>
                                          <v-list-item-content>
                                            <v-list-item-title
                                              v-text="item.title"
                                              style="color: black"
                                            ></v-list-item-title>

                                            <v-list-item-subtitle
                                              style="color: #1565c0"
                                              class="font-weight-medium"
                                              v-text="item.headline"
                                            ></v-list-item-subtitle>

                                            <v-list-item-subtitle
                                              v-html="
                                                `${item.subtitle.substr(
                                                  0,
                                                  50
                                                )} ...`
                                              "
                                            ></v-list-item-subtitle>
                                          </v-list-item-content>

                                          <v-list-item-action>
                                            <v-list-item-action-text
                                              v-html="
                                                getListItemAction(item.action)
                                              "
                                            ></v-list-item-action-text>
                                          </v-list-item-action>
                                        </template>
                                      </v-list-item>

                                      <v-divider
                                        v-if="
                                          index < inactiveJobsItems.length - 1
                                        "
                                        :key="index"
                                        inset
                                        style="
                                          color: #6b6868;
                                          margin-left: 0px;
                                          max-width: 100% !important;
                                        "
                                      ></v-divider>
                                    </template>

                                    <v-pagination
                                      v-model="page1"
                                      :length="
                                        Math.ceil(
                                          inactiveJobsItems.length / perPage1
                                        )
                                      "
                                      circle
                                    >
                                    </v-pagination>
                                  </v-list-item-group>
                                </v-list>
                              </v-col>
                            </v-row>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>

            <v-row>
              <ViewJobOffer
                :display-dialog="displayJobOffer"
                :job-offer="jobOfferToView"
                v-if="renderViewJobModal"
                :hideModalComponentCallback="hideModalComponent"
                v-bind:display-save-button-props="true"
              />
            </v-row>
          </v-card>
        </v-col>
      </v-row>
      <v-snackbar
        v-model="creationSnackbarAlertSuccess"
        rounded="pill"
        elevation="24"
        color="green darken-3"
        width="100%"
      >
        <span class="text-subtitle-1">
          Votre nouvelle offre a bien été publiée.
        </span>
        <template v-slot:action="{ attr }">
          <v-btn
            color="black"
            text
            v-bind="attr"
            @click="creationSnackbarAlertSuccess = false"
          >
            Fermer
          </v-btn>
        </template>
      </v-snackbar>
      <v-snackbar
        v-model="updatedSnackbarAlertSuccess"
        rounded="pill"
        elevation="24"
        color="green darken-3"
        width="100%"
      >
        <span class="text-subtitle-1"> L'offre a bien été mise à jour. </span>
        <template v-slot:action="{ attr }">
          <v-btn
            color="black"
            text
            v-bind="attr"
            @click="updatedSnackbarAlertSuccess = false"
          >
            Fermer
          </v-btn>
        </template>
      </v-snackbar>
      <v-snackbar
        v-model="deletedSnackbarAlertSuccess"
        rounded="pill"
        elevation="24"
        color="green darken-3"
        width="100%"
      >
        <span class="text-subtitle-1"> L'offre a bien été supprimée. </span>
        <template v-slot:action="{ attr }">
          <v-btn
            color="black"
            text
            v-bind="attr"
            @click="deletedSnackbarAlertSuccess = false"
          >
            Fermer
          </v-btn>
        </template>
      </v-snackbar>
      <v-snackbar
        v-model="enabledSnackbarAlertSuccess"
        rounded="pill"
        elevation="24"
        color="green darken-3"
        width="100%"
      >
        <span class="text-subtitle-1">
          L'offre a bien été réactiver. Elle est désormais accessible aux
          candidats.
        </span>
        <template v-slot:action="{ attr }">
          <v-btn
            color="black"
            text
            v-bind="attr"
            @click="enabledSnackbarAlertSuccess = false"
          >
            Fermer
          </v-btn>
        </template>
      </v-snackbar>
      <v-snackbar
        v-model="disabledSnackbarAlertSuccess"
        rounded="pill"
        elevation="24"
        color="green darken-3"
        width="100%"
      >
        <span class="text-subtitle-1">
          L'offre a bien été désactivée. Elle n'apparaîtra plus dans les
          résultats.
        </span>
        <template v-slot:action="{ attr }">
          <v-btn
            color="black"
            text
            v-bind="attr"
            @click="disabledSnackbarAlertSuccess = false"
          >
            Fermer
          </v-btn>
        </template>
      </v-snackbar>
    </v-container>
  </v-main>
</template>

<script>
import HttpClient from "@/services/HttpClient/HttpClient";
import { timeSince } from "@/helper/DateTimeHelper.js";
import Vue from "vue";
import ViewJobOffer from "@/components/Candidate/ViewJobOffer";

export default Vue.extend({
  name: "CompanyOffers",
  components: { ViewJobOffer },
  data: function () {
    return {
      tab: null,
      items: ["Offres d'emplois en ligne", "Offres d'emplois désactivées"],
      selected: [0],
      creationSnackbarAlertSuccess: false,
      updatedSnackbarAlertSuccess: false,
      disabledSnackbarAlertSuccess: false,
      deletedSnackbarAlertSuccess: false,
      enabledSnackbarAlertSuccess: false,
      snackbarAlertFailed: false,
      jobOffers: [],
      activeJobsItems: [],
      inactiveJobsItems: [],
      page: 1,
      page1: 1,
      perPage: 5,
      perPage1: 5,
      displayJobOffer: false,
      jobOfferToView: null,
      renderViewJobModal: false,
    };
  },
  created() {
    if (this.$route.query.success === null) {
      this.creationSnackbarAlertSuccess = true;
    } else if (this.$route.query.updated === null) {
      this.updatedSnackbarAlertSuccess = true;
    } else if (this.$route.query.disabled === null) {
      this.disabledSnackbarAlertSuccess = true;
    } else if (this.$route.query.deleted === null) {
      this.deletedSnackbarAlertSuccess = true;
    } else if (this.$route.query.enabled === null) {
      this.enabledSnackbarAlertSuccess = true;
    }
  },
  mounted() {
    this.initializeComponent();
  },
  computed: {
    updateVisibleJobs: function () {
      return this.activeJobsItems.slice(
        (this.page - 1) * this.perPage,
        this.page * this.perPage
      );
    },

    updateDisabledVisibleJobs: function () {
      return this.inactiveJobsItems.slice(
        (this.page1 - 1) * this.perPage1,
        this.page1 * this.perPage1
      );
    },
  },
  watch: {},
  methods: {
    getListItemAction(elt) {
      return (
        "<ul>" +
        "<li> Publié il y a " +
        timeSince(new Date(elt.createdAt)) +
        "</li>" +
        "<li class='font-weight-bold' style='color: #8787ef'> Candidatures : " +
        elt.applications.length +
        "</li>" +
        "</ul>"
      );
    },
    viewJobOffer: function (offerId) {
      const offer = this.jobOffers.filter((elt) => elt.id === offerId);
      if (offer.length !== 1) {
        alert("une erreur s'est produite");
      } else {
        this.jobOfferToView = offer[0];
        this.displayJobOffer = true;
        this.renderViewJobModal = true;
      }
    },
    hideModalComponent: function () {
      this.renderViewJobModal = false;
    },
    initializeComponent: function () {
      const httpClient = new HttpClient();
      httpClient
        .getCompanyJobOffers(localStorage.getItem("jwt-token"))
        .then((value) => {
          this.jobOffers = value.data;
          this.activeJobsItems = [];
          this.inactiveJobsItems = [];
          value.data.map((elt) => {
            if (elt.isActive) {
              this.activeJobsItems.push({
                id: elt.id,
                action: elt,
                headline: "",
                subtitle: elt.description,
                title: elt.job.name + " - " + elt.type.name,
              });
            } else {
              this.inactiveJobsItems.push({
                id: elt.id,
                action: elt,
                headline: "",
                subtitle: elt.description,
                title: elt.job.name + " - " + elt.type.name,
              });
            }
          });
        })
        .catch((error) => {
          console.log(error);

          if (error.response.status === 401) {
            this.$router.push("/logout");
          } else {
            alert("Une erreur s'est produite");
          }
        });
    },
  },
});
</script>

<style scoped></style>
